module.exports = __webpack_public_path__ + "media/effects-8.6c7d5aaa.webm";